<div class="container-fluid">
  <app-pagetitle title="Sales Representatives" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="main-card-container">
    <div class="card">
      <div class="card-body">

        <!-- Header Section -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="card-title mb-0">Sales Reps</h4>

          <div class="d-flex align-items-center gap-2">
            <div class="dropdown" ngbDropdown>
              <button class="btn btn-light" ngbDropdownToggle>
                <i class="mdi mdi-dots-vertical"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a href="javascript:void(0);" class="dropdown-item">
                  <i class="mdi mdi-upload me-2"></i>Import Sales Rep
                </a>
                <a href="javascript:void(0);" class="dropdown-item">
                  <i class="mdi mdi-download me-2"></i>Export Sales Rep
                </a>
              </div>
            </div>
            <button class="btn btn-light" (click)="refresh()" ngbTooltip="Refresh">
              <i class="mdi mdi-refresh"></i>
            </button>
          </div>
        </div>

        <!-- Insights (moved OUTSIDE header row for proper layout) -->
        <div class="row g-3 mb-4">
          <!-- Top 10 by Boards -->
          <div class="col-lg-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="text-muted mb-3">
                  <i class="mdi mdi-microchip me-1"></i>Top 10 Reps by Boards
                </h6>
                <table class="table table-sm align-middle mb-0">
                  <tbody>
                    <tr *ngFor="let r of top10ByBoards; index as i">
                      <td class="text-muted w-1">{{ i + 1 }}</td>
                      <td>{{ r.firstName }} {{ r.lastName }}</td>
                      <td class="text-end">
                        <span class="badge bg-primary">{{ r.numBoards }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Top 10 by Monthly -->
          <!-- <div class="col-lg-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="text-muted mb-3">
                  <i class="mdi mdi-cash-multiple me-1"></i>Top 10 by Monthly
                </h6>
                <table class="table table-sm align-middle mb-0">
                  <tbody>
                    <tr *ngFor="let r of top10ByMonthly; index as i">
                      <td class="text-muted w-1">{{ i + 1 }}</td>
                      <td>{{ r.firstName }} {{ r.lastName }}</td>
                      <td class="text-end">
                        <span class="badge bg-success">
                          ${{ (r.monthlyPayment || 0) | number:'1.0-0' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> -->
        </div>

        <!-- Action Buttons -->
        <div class="mb-4">
          <button type="button" class="btn btn-primary w-100 w-sm-auto" (click)="onAddNew(addEditModal)">
            <i class="mdi mdi-plus-circle me-1"></i>Add Sales Rep
          </button>
        </div>

        <!-- Search Box -->
        <div class="search-box mb-4">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              placeholder="Search sales reps..."
              [(ngModel)]="term"
              (ngModelChange)="onSearch()"
            />
            <i class="mdi mdi-magnify search-icon"></i>
          </div>
        </div>

        <!-- Table Section -->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="sticky-col">
                  <button type="button" class="btn btn-link p-0 text-reset text-decoration-none" (click)="sortBy('name')">
                    Name <i class="mdi" [ngClass]="sortIcon('name')"></i>
                  </button>
                </th>
                <th>
                  <button type="button" class="btn btn-link p-0 text-reset text-decoration-none" (click)="sortBy('customerNumber')">
                    Customer # <i class="mdi" [ngClass]="sortIcon('customerNumber')"></i>
                  </button>
                </th>
                <th>
                  <button type="button" class="btn btn-link p-0 text-reset text-decoration-none" (click)="sortBy('contact')">
                    Contact <i class="mdi" [ngClass]="sortIcon('contact')"></i>
                  </button>
                </th>
                <th class="text-end">
                  <button type="button" class="btn btn-link p-0 text-reset text-decoration-none" (click)="sortBy('monthlyPayment')">
                    Monthly <i class="mdi" [ngClass]="sortIcon('monthlyPayment')"></i>
                  </button>
                </th>
                <th class="text-end">
                  <button type="button" class="btn btn-link p-0 text-reset text-decoration-none" (click)="sortBy('numBoards')">
                    Boards <i class="mdi" [ngClass]="sortIcon('numBoards')"></i>
                  </button>
                </th>
                <th>
                  <button type="button" class="btn btn-link p-0 text-reset text-decoration-none" (click)="sortBy('enabled')">
                    Status <i class="mdi" [ngClass]="sortIcon('enabled')"></i>
                  </button>
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredSalesRep; trackBy: trackRep">
                <td class="sticky-col">
                  <div class="d-flex flex-column">
                    <span>{{item.firstName}} {{item.lastName}}</span>
                    <small class="text-muted">{{item.username}}</small>
                  </div>
                </td>
                <td>{{item.customerNumber}}</td>
                <td>
                  <div class="d-flex flex-column">
                    <span>{{item.phoneNumber}}</span>
                    <small class="text-muted">{{item.primaryEmail}}</small>
                  </div>
                </td>
                <td class="text-end font-monospace">${{item.monthlyPayment || 0}}</td>
                <td class="text-end font-monospace">{{item.numBoards}}</td>
                <td>
                  <div class="d-flex flex-column gap-2">
                    <!-- Status Toggles -->
                    <div class="form-check form-switch">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [checked]="item.enabled"
                        (change)="onCheckBoxChanged($event, item)"
                        id="enabled-{{item.id}}"
                      />
                      <label class="form-check-label" for="enabled-{{item.id}}">Enabled</label>
                    </div>

                    <div class="form-check form-switch">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [checked]="item.tenDollarEnabled"
                        (change)="onTenDollarCheckBoxChanged($event, item)"
                        id="tenDollar-{{item.id}}"
                      />
                      <label class="form-check-label" for="tenDollar-{{item.id}}">$10/Day</label>
                    </div>

                    <div class="form-check form-switch">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [checked]="item.fiveDollarEnabled"
                        (change)="onFiveDollarCheckBoxChanged($event, item)"
                        id="fiveDollar-{{item.id}}"
                      />
                      <label class="form-check-label" for="fiveDollar-{{item.id}}">$5/Day</label>
                    </div>

                    <div class="form-check form-switch">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [checked]="item.autoSendActivationText"
                        (change)="onTextCheckBoxChanged($event, item)"
                        id="activation-{{item.id}}"
                      />
                      <label class="form-check-label" for="activation-{{item.id}}">Auto Text</label>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex gap-2">
                    <!-- Machines button moved here (per-row) so 'item' exists -->
                    <button class="btn btn-sm btn-light" (click)="openRepMachines(item, repMachinesModal)" ngbTooltip="Machines">
                      <i class="mdi mdi-menu"></i>
                    </button>

                    <button class="btn btn-sm btn-light" (click)="onEdit(item, addEditModal)" ngbTooltip="Edit">
                      <i class="mdi mdi-pencil"></i>
                    </button>
                    <button class="btn btn-sm btn-light" (click)="onResetPassword(item)" ngbTooltip="Reset Password">
                      <i class="mdi mdi-lock-reset"></i>
                    </button>
                    <button class="btn btn-sm btn-light text-danger" (click)="onDelete(item.id)" ngbTooltip="Delete">
                      <i class="mdi mdi-trash-can"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Empty State -->
          <div *ngIf="filteredSalesRep?.length === 0" class="text-center py-5">
            <p class="text-muted mb-0">No sales reps found</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Modal -->
  <ng-template #addEditModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{addEditMode}} Sales Rep</h4>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="saleRepAddEditFormGroup">
        <!-- Basic Info Section -->
        <div class="form-section mb-4">
          <h5 class="section-title">Basic Information</h5>

          <div class="row g-3">
            <div class="col-12 col-md-6">
              <label class="form-label">Username</label>
              <input type="text" class="form-control" formControlName="username" placeholder="Enter username">
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Customer Number</label>
              <input type="text"
                     class="form-control"
                     formControlName="customerNumber"
                     placeholder="Generated automatically"
                     [readonly]="addEditMode === 'Add'">
              <small *ngIf="addEditMode === 'Add'" class="form-text text-muted">
                Generated automatically from the current customer list.
              </small>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">First Name</label>
              <input type="text" class="form-control" formControlName="firstName" placeholder="Enter first name">
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Last Name</label>
              <input type="text" class="form-control" formControlName="lastName" placeholder="Enter last name">
            </div>
          </div>
        </div>

        <!-- Contact Info Section -->
        <div class="form-section mb-4">
          <h5 class="section-title">Contact Information</h5>

          <div class="row g-3">
            <div class="col-12 col-md-6">
              <label class="form-label">Phone Number</label>
              <input type="tel" class="form-control" formControlName="phoneNumber" placeholder="000-000-0000">
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Email Address</label>
              <input type="email" class="form-control" formControlName="primaryEmail" placeholder="Enter email">
            </div>
          </div>
        </div>

        <!-- Address Section -->
        <div class="form-section mb-4" formGroupName="businessAddress">
          <h5 class="section-title">Business Address</h5>

          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">Street Address 1</label>
              <input type="text" class="form-control" formControlName="streetAddress1" placeholder="Enter street address">
            </div>

            <div class="col-12">
              <label class="form-label">Street Address 2</label>
              <input type="text" class="form-control" formControlName="streetAddress2" placeholder="Enter suite, unit, etc.">
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">City</label>
              <input type="text" class="form-control" formControlName="city" placeholder="Enter city">
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">State</label>
              <input type="text" class="form-control" formControlName="state" placeholder="Enter state">
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">ZIP Code</label>
              <input type="text" class="form-control" formControlName="zipCode" placeholder="Enter ZIP code">
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Country</label>
              <input type="text" class="form-control" formControlName="country" placeholder="Enter country">
            </div>
          </div>
        </div>

        <!-- Collector Assignment Section -->
        <div class="col-12 col-md-6">
          <label class="form-label">Collector</label>
          <select class="form-select" formControlName="collectorId">
            <option value="">-- No Collector --</option>
            <option *ngFor="let collector of collectors" [value]="collector.id">
              {{ collector.firstName }} {{ collector.lastName }} ({{ collector.username }})
            </option>
          </select>
        </div>

        <!-- Status Section -->
        <div class="form-section">
          <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" formControlName="enabled" id="enabled-input">
            <label class="form-check-label" for="enabled-input">Enable Sales Rep</label>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="modal.close('Save click')">Save Changes</button>
    </div>
  </ng-template>

  <!-- Machines Modal -->
  <ng-template #repMachinesModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">
        Machines — {{selectedRep?.firstName}} {{selectedRep?.lastName}}
      </h5>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <div *ngIf="repMachinesLoading" class="text-center py-4">
        <div class="spinner-border" role="status"></div>
      </div>

      <div *ngIf="!repMachinesLoading" class="table-responsive">
        <table class="table table-sm table-hover align-middle">
          <thead>
            <tr>
              <th>Asset</th>
              <th>Serial</th>
              <th>Game</th>
              <th>Location</th>
              <th>City</th>
              <th>State</th>
              <th class="text-end">Cash In (MTD)</th>
              <th class="text-end">Cash Out (MTD)</th>
              <th class="text-end">Net (MTD)</th>
              <th class="text-end">Last Read</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let m of repMachines">
              <td>{{ m.assetTag }}</td>
              <td>{{ m.serialNumber }}</td>
              <td>{{ m.gamePackageName }}</td>
              <td>{{ m.locationName }}</td>
              <td>{{ m.city }}</td>
              <td>{{ m.state }}</td>
              <td class="text-end">{{ m.cashIn | number:'1.0-0' }}</td>
              <td class="text-end">{{ m.cashOut | number:'1.0-0' }}</td>
              <td class="text-end" [ngClass]="{'text-success': m.net >= 0, 'text-danger': m.net < 0}">
                {{ m.net | number:'1.0-0' }}
              </td>
              <td class="text-end">{{ m.lastRead | date:'short' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-template>
</div>
